import React, {createContext, useMemo, useState} from 'react';
import {ThemeProvider} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import {darkTheme, lightTheme} from '../theme';
import {useMediaQuery} from '@mui/material';

export const ThemeContext = createContext();

const ThemeContextProvider = ({children}) => {
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

    const [isDarkMode, setIsDarkMode] = useState(() => {
        const savedPreference = sessionStorage.getItem('darkMode');

        return savedPreference !== null
            ? JSON.parse(savedPreference)
            : prefersDarkMode;
    });

    const toggleTheme = () => {
        setIsDarkMode((prev) => {
            const newValue = !prev;
            sessionStorage.setItem('darkMode', JSON.stringify(newValue));
            return newValue;
        });
    };

    const theme = useMemo(() => (isDarkMode ? darkTheme : lightTheme), [isDarkMode]);

    return (
        <ThemeContext.Provider value={{isDarkMode, toggleTheme}}>
            <ThemeProvider theme={theme}>
                <CssBaseline/>
                {children}
            </ThemeProvider>
        </ThemeContext.Provider>
    );
};

export default ThemeContextProvider;
